import ee from 'event-emitter';

export type AlfrescoApiClientPromise<T = any> = Promise<T> & {
  on: ee.EmitterMethod;
  off: ee.EmitterMethod;
  once: ee.EmitterMethod;
  emit: (type: string, ...args: any[]) => void;
  abort?: () => void;
};
